var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import { useMe } from '@/atoms/Auth';
import ActivityReportSummary from '@/components/ActivityReportSummary';
import useAppComponents from '@/hooks/useAppComponents';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
export default function SummarySection() {
    var _a, _b;
    const { api } = useAppComponents();
    const { userInfo } = useMe();
    const { data } = useQuery({
        queryKey: ['ReviewReport'],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.getReviewActivityReportPost();
            return response.data;
        }),
    });
    return (_jsx(ActivityReportSummary, { type: "review", nickname: userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickname, todayCount: (_a = data === null || data === void 0 ? void 0 : data.todayReviewedCount) !== null && _a !== void 0 ? _a : 0, monthCount: (_b = data === null || data === void 0 ? void 0 : data.thisMonthReviewedCount) !== null && _b !== void 0 ? _b : 0 }));
}
